import { Component, Input, OnChanges } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-lead-activity-chart',
  templateUrl: './lead-activity-chart.component.html',
  styleUrls: ['./lead-activity-chart.component.scss']
})
export class LeadActivityChartComponent implements OnChanges {
  @Input() data: any;
  @Input() id: string = 'lead-activity-chart';
  @Input() title: string = 'Lead Activity Chart';
  @Input() isDaily: boolean = false;
  @Input() chartType: 'calls' | 'emails' = 'calls';

  selectedMonth: string = '';
  chartInstance: any;

  ngOnChanges() {
    if (this.data) {
      // Set current month if selectedMonth is not already chosen or available in data
      const currentMonth = new Date().toLocaleString('default', { month: 'short' });
      const availableMonths = this.getMonthOptions();

      if (!this.selectedMonth || !availableMonths.includes(this.selectedMonth)) {
        this.selectedMonth = availableMonths.includes(currentMonth) ? currentMonth : availableMonths[0];
      }

      setTimeout(() => this.renderChart(), 100);
    }
  }

  renderChart() {
    if (!this.data) return;

    const ctx: any = document.getElementById("canvas__" + this.id);
    if (!ctx) return;

    const context = ctx.getContext('2d');

    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }

    let labels: string[] = [];
    let values: number[] = [];

    if (this.isDaily) {
      const monthData = this.data.daily[this.selectedMonth] || {};
      const monthIndex = new Date(`${this.selectedMonth} 1, 2025`).getMonth();
      const daysInMonth = new Date(2025, monthIndex + 1, 0).getDate();

      labels = Array.from({ length: daysInMonth }, (_, i) => (i + 1).toString());
      values = labels.map(day => monthData[day] ?? 0);
    } else {
      labels = Object.keys(this.data.yearly);
      values = Object.values(this.data.yearly);
    }

    this.chartInstance = new Chart(context, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          data: values,
          borderWidth: 3,
          borderColor: '#F0950C',
          backgroundColor: '#F0950C',
          pointBackgroundColor: '#F0950C',
          pointBorderColor: '#F0950C',
        }]
      },
      options: {
        responsive: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: true,
            mode: 'index',
            intersect: false,
            callbacks: {
              labelColor: (context) => {
                const color = context.dataset.borderColor as string;
                return {
                  borderColor: color,
                  backgroundColor: color,
                  borderWidth: 2,
                  borderRadius: 2,
                };
              },
            },
          }
        },
        animation: {
          duration: 1,
          onComplete: ({ chart }) => {
            const ctx = chart.ctx;
            chart.config.data.datasets.forEach((dataset, i) => {
              const meta = chart.getDatasetMeta(i);
              meta.data.forEach((bar, index) => {
                const data = dataset.data[index];
                // ctx.fillText(data, bar.x, bar.y - 5); // optional data labels
              });
            });
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            min: 0
          }
        }
      }
    });
  }

  onMonthChange(event: any) {
    this.selectedMonth = event.target.value;
    this.renderChart();
  }

  getMonthOptions(): string[] {
    return Object.keys(this.data?.daily || {});
  }
}
